<template>
    <b-container id="question-for-print" fluid class="py-2 px-0 position-relative">

        <!-- Question & Question info 영역 -->
        <h4 class="fw-600 px-7 pb-2 border-bottom border-color-gray-300">
            {{ showTranslation(question_name, question_name_e, question_name_c) }}
        </h4>
        <!-- <div id="question_infobox" :class="[ question_infobox != '' ? 'px-7 blue7 bg-blue2 f-95':'', 'py-2 mb-5 border-0 ']"  v-html="question_infobox"></div> -->

        <!-- Sub-component 영역 -->
        <div v-if="subs_loaded && subs.length > 0" class="px-7 pb-5 mb-4" :key="pipeline_key">
            <sub-component v-for="(item, index) in subs" :key="item.sub_code"
                :item="item"
                :sub_type="item.sub_type"
                :view_pipe_line="view_pipe_line"
                :is_final_sub_component="index === subs.length-1"
                :is_disabled_by_parent="false"
                :print_mode="true"
                :no_answers="no_answers"
                @update-pipeline="handleUpdatePipeline"
                @sub-load-finished="handleSubLoadFinished"
                @update-sub-for-print="handleUpdateSubForPrint"
                >
            </sub-component>
        </div>
        
        <!-- Question not editable -->
        <div v-if="is_writable==false" class="w-100 question-blocked">
            <b-alert show dismissible class="question-block-alert w-100 d-flex justify-content-center align-items-center">
               <div class="text-center fw-500"> <fa icon="info-circle" class='mr-1'></fa> 이 문항은 보기만 가능합니다. <br> <span class="f-90 fw-400">작성 및 편집을 원하실 경우 관리자에게 문의하세요.</span></div>
            </b-alert>
        </div>

</b-container>
</template>

<script>
import { mapState } from 'vuex'
import * as th from 'tree-helper'
import SubComponent from '@core_components/client/components/subs/SubComponent.vue'
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';

export default {
    name: "QuestionForPrint",
    props: {
        question_code: {
            type: String,
            default: ''
        },
        no_answers: {
            type: Boolean,
            default: false,
        },
        is_final_question_code: {
            type: Boolean,
            default: false
        },
        view_pipe_line: {
            type: Boolean,
            default: true,
        }
    },
    components: {
        SubComponent
    },
    data () {
        return {
            question_name: '',
            question_name_e: '',
            question_name_c: '',
            question_infobox: '',
            template_name: '',
            is_writable: true,
            is_visible: true,
            is_completed: false,
            comment: '',
            pipeline_key: 100,
            subs: [],
            subs_loaded: false,
            load_complete_sub: [],
            question_contents: [],

            load_finished: false
        }
    },
    computed: {
        ...mapState(['company_id', 'campaign_in_progress', 'campaign', 'template_in_progress', 'template_tree', 'view_mode']),
        ...mapState('questions',['answer_company']),
        target_campaign_id () {
            if (this.no_answers) {
                return null
            }

            if (this.$route.query.cmp ?? this.$route.query.campaign_id) {
                return this.$route.query.cmp ?? this.$route.query.campaign_id
            }
            return this.view_mode === 'provider'
                ? this.answer_company.campaign_id
                : this.campaign_in_progress.campaign_id
        },
        target_company_id () {
            if (this.no_answers) {
                return null
            }

            if (this.$route.query.cpn ?? this.$route.query.company_id) {
                return this.$route.query.cpn ?? this.$route.query.company_id
            }
            
            return this.view_mode === 'provider'
                ? this.answer_company.company_id
                : this.company_id
        },
        target_template_contents () {
            if (this.view_mode=='provider') {
                return this.template_in_progress.template_contents
            } else {
                return this.template_tree.template_contents
            }
        },
        is_disabled_by_parent(){
            if ((this.campaign_in_progress && this.campaign_in_progress.campaign_state == '완료') || (this.campaign && this.campaign.campaign_state == '완료')) {
                return true
            } else {
                return false
            }
        }
    },
    async created () {
        await this.initializeQuestion(this.question_code)
    },
    beforeDestroy () {
        this.question_name = ''
        this.question_name_e = ''
        this.question_name_c = ''
        this.question_infobox = ''
        this.template_name = ''
        this.is_writable = true
        this.is_visible = true
        this.is_completed = false
        this.comment = ''
        this.pipeline_key = 100
        this.subs = []
        this.subs_loaded = false
        this.load_complete_sub = []
        this.question_contents = []

        this.load_finished = false
    },
    methods: {
        async initializeQuestion (question_code) {
            th.breadthFirstSearch(this.target_template_contents, async (node) => {
                if (node.question_code === question_code) {
                    this.comment = node.comment
                    this.question_name = node.question_name
                    this.question_name_e = node.question_name_e
                    this.question_name_c = node.question_name_c
                    this.question_infobox = node.question_infobox
                    this.is_writable = node.is_writable
                    this.is_visible = node.is_visible
                    
                    if (typeof node.question_contents === 'string') {
                        this.question_contents = JSON.parse(node.question_contents)
                    } else {
                        this.question_contents = node.question_contents
                    }
                    
                    this.is_completed = node.is_completed
                }
            })
            
            if (!this.question_contents.length) {
                this.handleLoadFinished()
            }

            await this.readSubs(this.question_contents)
        },
        async readSubs (question_contents) {
            this.subs = []
            this.subs_loaded = false
            let _subs = []
            
            const _question_contents = Array.isArray(question_contents) ? question_contents.join(',') : question_contents
            let _res_subs = null
            if (this.target_company_id && this.target_campaign_id) {
                _res_subs = await this.$axios.get('/subs', {
                    params: {
                        sub_codes: _question_contents,
                        company_id: this.target_company_id,
                        campaign_id: this.target_campaign_id
                    }
                })
            } else {
                _res_subs = await this.$axios.get('/subs/init', {
                    params: { sub_codes: _question_contents }
                })
            }
            
            if (_res_subs.data && _res_subs.data.length) {
                _subs = _question_contents.split(',').reduce((_reordered_subs, _sub_code) => {
                    let subs = _res_subs.data.find(({ sub_code }) => sub_code === _sub_code)
                    if (subs && subs.sub_type !== 'guide_text2') {
                        _reordered_subs.push(generateSubcomponentDataBy(subs, this.question_code))
                    }
                    return _reordered_subs
                }, [])
            }

            this.subs = _subs
            this.$nextTick(() => {
                this.subs_loaded = true
            })
        },
        handleUpdateSubForPrint (updated_sub) {
            const idx = this.subs.findIndex(item => item.sub_code === updated_sub.sub_code)
            if (idx > -1) {
                this.$set(this.subs, idx, generateSubcomponentDataBy({ ...this.subs[idx], ...updated_sub }))
            }
        },
        handleSubLoadFinished (loaded_sub_code) {
            this.load_complete_sub.push(loaded_sub_code)
            
            if (this.load_complete_sub.length === this.subs.length) {
                this.handleLoadFinished()
            }
        },
        handleLoadFinished(){
            this.$emit('load-finished', this.question_code)
        },
        handleUpdatePipeline(){
            this.pipeline_key += 1
        }
    }
}
</script>
<style>

.question-blocked{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 50;
    flex-grow: 1;
    height: 100%;
    background: rgb(255,255,255, 0.2);
}

.question-block-alert {
    top: 0px;
    height: 60px;
    background-color: rgba(0,0,0,0.5);
    color:white;
    border:0;
    border-radius: 0;
    z-index: 60;
}

#question_infobox > a {
    color: var(--blue7);
}

</style>
